<template>
  <iframe
    v-if="iframeSrc"
    ref="iframe"
    sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-downloads"
    :src="iframeSrc"
    :style="{ display: 'block', border: 'none', width: '100%', height: '500px' }"
  />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: 'conversation'
    }
  },
  computed: {
    ...mapGetters(['currentLang']),
    iframeSrc() {
      if (!this.currentLang) return ''
      return `https://event-tracking.zwiz.app/${this.currentLang}/links/form/event-tracking`
    }
  },
  mounted() {
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    handleMessage(e) {
      if (e.source !== this.$refs.iframe.contentWindow) return

      const { id, value } = e.data
      switch (id) {
        case 'link-form-event-tracking-ready': {
          this.$refs.iframe.contentWindow.postMessage(
            {
              id: 'link-form-event-tracking-init',
              value: {
                label: this.value.label || '',
                category: this.value.category || '',
                action: this.value.action || '',
                value: this.value.value || ''
              }
            },
            '*'
          )
          break
        }
        case 'link-form-event-tracking-submit': {
          this.$emit('input', {
            ...this.value,
            type: this.value.type || this.type,
            ...value
          })
          break
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/EventTrackingForm.vue